/**
 * Border Radius schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BP, ISchemaConstString, ISchemaValue, ISchemaValueStringOpts } from "@adapptio/lib-blueprint";

import { termsEditor } from "../terms";

/**
 * Border Radius schema
 *
 * @param opts Options
 */
export function BorderRadiusSchema(
	opts: Partial<ISchemaValueStringOpts> = { alias: "borderRadius" }
): ISchemaValue<ISchemaConstString> {
	return BP.String({
		...termsEditor.schemas.common.borderRadius,
		default: "",
		...opts
	});
}
